import { Component } from '@angular/core';
import { DataService } from './data.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  constructor(public data: DataService) { }
}



// WEBPACK FOOTER //
// /home/itheunrealist/techpixels/src/app/app.component.ts